import ItemChannelTab from "../../ChannelManagment/ChannelTab/ItemChannelTab/ItemChannelTab";

function ContentTab({ activeTab, chooseActiveTab }) {

    return (
        <div className="flex flex-row-reverse items-center px-10 pt-4 border-b border-slate-200">
            <ItemChannelTab
                text="علم و تکنولوژی"
                num={0}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="داستانی"
                num={1}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="روانشناسی"
                num={2}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="اقتصاد"
                num={3}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="مدیریت"
                num={4}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="اجتماعی"
                num={5}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="تاریخی"
                num={6}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="سلامت"
                num={7}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="فلسفه"
                num={8}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="موفقیت"
                num={9}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="زندگی نامه"
                num={10}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
        </div>
    )
}
export default ContentTab;